if (!customElements.get('lamp-switch')) {
  customElements.define(
    'lamp-switch',
    class LampSwitch extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.lamp-switch__btn');
        if (!this.button) return;
        this.targets = this.getDarkModeTargets();
        this.button.addEventListener('click', this.toggle.bind(this));
      }

      // Dark mode is applied to the header bar, the breadcrumb and the
      // main-product block only — not the whole page (footer, related
      // products, etc. stay untouched), and never to the header's
      // menu-drawer/overlays so their fixed positioning isn't affected.
      getDarkModeTargets() {
        const targets = [];
        const header = document.querySelector('.header-section > header');
        if (header) targets.push(header);

        const breadcrumb = document.querySelector('.section--breadcrumb');
        if (breadcrumb) targets.push(breadcrumb);

        const mainProduct = document.querySelector('[id^="MainProduct-"]');
        if (mainProduct) targets.push(mainProduct);

        return targets;
      }

      toggle() {
        const isOn = this.button.getAttribute('aria-pressed') === 'true';
        const nextState = !isOn;

        this.button.setAttribute('aria-pressed', String(nextState));
        this.classList.toggle('is-on', nextState);

        this.targets.forEach((el) => {
          el.classList.toggle('lamp-dark-mode', nextState);
        });

        // The gallery's prev/next+dots pill (.slider-controls) has its
        // translucent white background re-applied inline by the theme's own
        // slider script, which beats any plain CSS rule (including
        // !important ones) we add for it. Setting it inline ourselves,
        // also !important, is the only thing that reliably wins.
        const sliderControls = document.querySelectorAll('.slider-controls');
        sliderControls.forEach((el) => {
          if (nextState) {
            el.style.setProperty('background-color', 'rgba(0, 0, 0, 0.55)', 'important');
          } else {
            el.style.removeProperty('background-color');
          }
        });
      }
    }
  );
}
